import effects from 'app/effects/effects'

export const changePasswordRemote = (model) =>
  effects.apis.updateUserPassword({
    currentPassword: model.currentPassword,
    newPassword: model.newPassword,
  })

export const setPassword = (model) =>
  effects.apis.authV2.setPassword({
    password: model.password,
  })

export const changePassword = (model) =>
  effects.apis.authV2.changePassword({
    currentPassword: model.currentPassword,
    newPassword: model.newPassword,
  })
